import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import ExpenseForm from '../../components/Expenses/ExpenseForm';

const ExpenseCreate = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Link
          to="/app/expenses"
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <FiArrowLeft className="mr-2" />
          Back to Expenses
        </Link>
        <h1 className="text-3xl font-bold text-gray-900">Create New Expense</h1>
        <p className="text-gray-600 mt-1">Record a new project expense</p>
      </div>

      <ExpenseForm />
    </div>
  );
};

export default ExpenseCreate;

